import React, { useState } from 'react';
import { SearchIcon, DownloadIcon } from 'lucide-react';
export function TransactionSummaryReport() {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [bank, setBank] = useState('');
  const [summaryResults, setSummaryResults] = useState<any[]>([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const banks = [{
    code: '',
    name: 'All Banks'
  }, {
    code: 'AMHRETAA',
    name: 'Amhara Bank S.C.'
  }, {
    code: 'AWINETAA',
    name: 'Awash Bank S.C.'
  }, {
    code: 'CBETETAA',
    name: 'Commercial Bank of Ethiopia (CBE)'
  }, {
    code: 'BUNAETAA',
    name: 'Bunna International Bank S.C.'
  }, {
    code: 'DASHETAA',
    name: 'Dashen Bank S.C.'
  }, {
    code: 'CBORETAA',
    name: 'Cooperative Bank of Oromia S.C. (COOP)'
  }, {
    code: 'ZEMEETAA',
    name: 'Zemen Bank S.C.'
  }, {
    code: 'NIBIETAA',
    name: 'NIB International Bank S.C. (NIB)'
  }, {
    code: 'HIJRETAA',
    name: 'Hibret Bank S.C.'
  }, {
    code: 'TSCPETAA',
    name: 'Tsehay Bank S.C.'
  }, {
    code: 'WEGAETAA',
    name: 'Wegagen Bank S.C.'
  }, {
    code: 'ABAYETAA',
    name: 'Abay Bank S.C.'
  }];
  // Sample data for summary report
  const sampleSummaryData = [{
    date: '2023-05-10',
    bankCode: 'AMHRETAA',
    bankName: 'Amhara Bank S.C.',
    successCount: 156,
    successValue: 785000,
    failedCount: 12,
    failedValue: 45000,
    totalCount: 168,
    totalValue: 830000
  }, {
    date: '2023-05-10',
    bankCode: 'AWINETAA',
    bankName: 'Awash Bank S.C.',
    successCount: 203,
    successValue: 945000,
    failedCount: 18,
    failedValue: 67000,
    totalCount: 221,
    totalValue: 1012000
  }, {
    date: '2023-05-09',
    bankCode: 'AMHRETAA',
    bankName: 'Amhara Bank S.C.',
    successCount: 142,
    successValue: 690000,
    failedCount: 9,
    failedValue: 32000,
    totalCount: 151,
    totalValue: 722000
  }, {
    date: '2023-05-09',
    bankCode: 'AWINETAA',
    bankName: 'Awash Bank S.C.',
    successCount: 187,
    successValue: 875000,
    failedCount: 14,
    failedValue: 51000,
    totalCount: 201,
    totalValue: 926000
  }, {
    date: '2023-05-08',
    bankCode: 'AMHRETAA',
    bankName: 'Amhara Bank S.C.',
    successCount: 128,
    successValue: 610000,
    failedCount: 7,
    failedValue: 28000,
    totalCount: 135,
    totalValue: 638000
  }, {
    date: '2023-05-08',
    bankCode: 'AWINETAA',
    bankName: 'Awash Bank S.C.',
    successCount: 172,
    successValue: 820000,
    failedCount: 11,
    failedValue: 42000,
    totalCount: 183,
    totalValue: 862000
  }, {
    date: '2023-05-07',
    bankCode: 'CBETETAA',
    bankName: 'Commercial Bank of Ethiopia (CBE)',
    successCount: 312,
    successValue: 1450000,
    failedCount: 24,
    failedValue: 95000,
    totalCount: 336,
    totalValue: 1545000
  }, {
    date: '2023-05-07',
    bankCode: 'DASHETAA',
    bankName: 'Dashen Bank S.C.',
    successCount: 165,
    successValue: 780000,
    failedCount: 13,
    failedValue: 48000,
    totalCount: 178,
    totalValue: 828000
  }];
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Validate date range
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      const diffTime = Math.abs(to.getTime() - from.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 90) {
        alert('Date range cannot exceed 90 days');
        setIsLoading(false);
        return;
      }
      if (from > to) {
        alert('From date must be before To date');
        setIsLoading(false);
        return;
      }
    }
    // Simulate API delay
    setTimeout(() => {
      // Filter sample data based on search criteria
      let results = [...sampleSummaryData];
      // Filter by bank if selected
      if (bank) {
        results = results.filter(item => item.bankCode === bank);
      }
      // Sort by date (newest first) and then by bank name
      results.sort((a, b) => {
        if (a.date !== b.date) {
          return b.date.localeCompare(a.date);
        }
        return a.bankName.localeCompare(b.bankName);
      });
      setSummaryResults(results);
      setHasSearched(true);
      setIsLoading(false);
    }, 800);
  };
  const handleReset = () => {
    setFromDate('');
    setToDate('');
    setBank('');
    setSummaryResults([]);
    setHasSearched(false);
  };
  const handleExport = (format: 'csv' | 'pdf') => {
    // In a real app, you would implement the actual export functionality
    alert(`Exporting as ${format.toUpperCase()}...`);
  };
  // Calculate totals for the footer row
  const calculateTotals = () => {
    return summaryResults.reduce((acc, curr) => {
      acc.successCount += curr.successCount;
      acc.successValue += curr.successValue;
      acc.failedCount += curr.failedCount;
      acc.failedValue += curr.failedValue;
      acc.totalCount += curr.totalCount;
      acc.totalValue += curr.totalValue;
      return acc;
    }, {
      successCount: 0,
      successValue: 0,
      failedCount: 0,
      failedValue: 0,
      totalCount: 0,
      totalValue: 0
    });
  };
  const totals = summaryResults.length > 0 ? calculateTotals() : null;
  return <div className="space-y-6" data-id="element-1003">
      <h1 className="text-2xl font-bold text-[#1A1F36]" data-id="element-1004">
        Transaction Summary Report
      </h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6" data-id="element-1005">
        <form onSubmit={handleSearch} className="space-y-6" data-id="element-1006">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1007">
            <div className="space-y-2" data-id="element-1008">
              <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700" data-id="element-1009">
                From Date
              </label>
              <input id="fromDate" type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" required data-id="element-1010" />
            </div>
            <div className="space-y-2" data-id="element-1011">
              <label htmlFor="toDate" className="block text-sm font-medium text-gray-700" data-id="element-1012">
                To Date
              </label>
              <input id="toDate" type="date" value={toDate} onChange={e => setToDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" required data-id="element-1013" />
            </div>
            <div className="space-y-2" data-id="element-1014">
              <label htmlFor="bank" className="block text-sm font-medium text-gray-700" data-id="element-1015">
                Bank
              </label>
              <select id="bank" value={bank} onChange={e => setBank(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" data-id="element-1016">
                {banks.map(bank => <option key={bank.code} value={bank.code} data-id="element-1017">
                    {bank.name}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-1018">
            <button type="submit" disabled={isLoading} className="px-4 py-2 bg-[#F58220] text-white rounded-md font-medium hover:bg-[#e07619] focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:ring-opacity-50 flex items-center" data-id="element-1019">
              {isLoading ? <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1020">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1021"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1022"></path>
                  </svg>
                  Generating...
                </> : <>
                  <SearchIcon size={16} className="inline mr-2" data-id="element-1023" />
                  Generate Summary
                </>}
            </button>
            <button type="button" onClick={handleReset} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50" data-id="element-1024">
              Reset
            </button>
          </div>
        </form>
      </div>
      {hasSearched && <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden" data-id="element-1025">
          <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1026">
            <h3 className="font-medium text-[#1A1F36]" data-id="element-1027">Summary Results</h3>
            {summaryResults.length > 0 && <div className="flex items-center gap-3" data-id="element-1028">
                <button onClick={() => handleExport('csv')} className="flex items-center bg-white border border-gray-300 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1029">
                  <DownloadIcon size={16} className="mr-2" data-id="element-1030" />
                  Export CSV
                </button>
                <button onClick={() => handleExport('pdf')} className="flex items-center bg-white border border-gray-300 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1031">
                  <DownloadIcon size={16} className="mr-2" data-id="element-1032" />
                  Export PDF
                </button>
              </div>}
          </div>
          {summaryResults.length === 0 ? <div className="p-8 text-center" data-id="element-1033">
              <p className="text-gray-500" data-id="element-1034">
                No transaction data found matching your search criteria.
              </p>
            </div> : <div className="overflow-x-auto" data-id="element-1035">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1036">
                <thead className="bg-gray-50" data-id="element-1037">
                  <tr data-id="element-1038">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1039">
                      Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1040">
                      Bank
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1041">
                      Success Count
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1042">
                      Success Value
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1043">
                      Failed Count
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1044">
                      Failed Value
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1045">
                      Total Count
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1046">
                      Total Value
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1047">
                  {summaryResults.map((item, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-1048">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1049">
                        {item.date}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1050">
                        {item.bankName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1051">
                        {item.successCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1052">
                        ETB {item.successValue.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1053">
                        {item.failedCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1054">
                        ETB {item.failedValue.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1055">
                        {item.totalCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1056">
                        ETB {item.totalValue.toLocaleString()}
                      </td>
                    </tr>)}
                </tbody>
                {totals && <tfoot className="bg-gray-100" data-id="element-1057">
                    <tr data-id="element-1058">
                      <td colSpan={2} className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1059">
                        Totals
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1060">
                        {totals.successCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1061">
                        ETB {totals.successValue.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1062">
                        {totals.failedCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1063">
                        ETB {totals.failedValue.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1064">
                        {totals.totalCount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-1065">
                        ETB {totals.totalValue.toLocaleString()}
                      </td>
                    </tr>
                  </tfoot>}
              </table>
            </div>}
        </div>}
    </div>;
}